import { useTranslation } from "@flare/i18n";

import { MessageBanner } from "@/components/design-system-components/message-banner";
import { TextField } from "@/components/Funnel/TextField";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { InputsContainer } from "../components/inputs-container";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";
import { useFunnelAnswers } from "../hooks/useFunnelAnswers";

const MAX_LENGTH = 64;

export default function OpposingParty() {
  const { t } = useTranslation();
  const { funnelAnswers } = useFunnelAnswers();

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle>{t("FUNNEL_OPPOSING_PARTY_TITLE")}</StepTitle>
          <InputsContainer className="mt-sp-6 space-y-sp-5 md:flex md:gap-sp-3 md:space-y-sp-0">
            <TextField
              name={funnelInputsNameMap.opposingPartyFirstName}
              label={t("FUNNEL_OPPOSING_PARTY_FIRST_NAME_INPUT_LABEL")}
              placeholder={t(
                "FUNNEL_OPPOSING_PARTY_FIRST_NAME_INPUT_PLACEHOLDER",
              )}
              validationErrorMessage={t(
                "FUNNEL_OPPOSING_PARTY_FIRST_NAME_INPUT_ERROR_MESSAGE",
              )}
              required
              maxLength={MAX_LENGTH}
            />
            <TextField
              name={funnelInputsNameMap.opposingPartyLastName}
              label={t("FUNNEL_OPPOSING_PARTY_LAST_NAME_INPUT_LABEL")}
              placeholder={t(
                "FUNNEL_OPPOSING_PARTY_LAST_NAME_INPUT_PLACEHOLDER",
              )}
              validationErrorMessage={t(
                "FUNNEL_OPPOSING_PARTY_LAST_NAME_INPUT_ERROR_MESSAGE",
              )}
              required
              maxLength={MAX_LENGTH}
            />
          </InputsContainer>
          <InputsContainer className="mb-sp-8 mt-sp-5">
            <TextField
              tel={{
                differentFrom: funnelAnswers.phone,
              }}
              name={funnelInputsNameMap.opposingPartyPhone}
              label={t("FUNNEL_OPPOSING_PARTY_PHONE_INPUT_LABEL")}
              placeholder={t("FUNNEL_OPPOSING_PARTY_PHONE_INPUT_PLACEHOLDER")}
              type="tel"
              validationErrorMessage={t(
                "FUNNEL_OPPOSING_PARTY_PHONE_INPUT_ERROR_MESSAGE",
              )}
              required
            />
          </InputsContainer>
          <MessageBanner
            variant="warning"
            className="mx-auto mb-sp-6 mt-sp-1 max-w-[520px]"
          >
            {t("FUNNEL_OPPOSING_PARTY_FEEDBACK")}
          </MessageBanner>
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
